module.exports = __webpack_public_path__ + "img/住宿水单示例.b4feb0a5.png";